/* PrintiLoop — quote request form helper + anchor navigation */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function readableName(el) {
    var label = el.dataset.plLabel;
    if (label) return label;
    if (el.id) {
      var forLabel = document.querySelector('label[for="' + el.id + '"]');
      if (forLabel) return forLabel.textContent.trim().replace(/\s+/g, ' ');
    }
    var wrap = el.closest('.pl-fl');
    var lbl = wrap ? wrap.querySelector('label') : null;
    return lbl ? lbl.textContent.trim().replace(/\s+/g, ' ') : el.name;
  }

  function valueOf(el) {
    if (el.tagName === 'SELECT') {
      var opt = el.options[el.selectedIndex];
      return opt ? opt.textContent.trim() : '';
    }
    return el.value.trim();
  }

  function initQuoteForm() {
    var form = document.querySelector('.pl-qf form');
    if (!form) return;

    var bodyField = form.querySelector('[data-pl-quote-body]');
    if (!bodyField) return;

    form.addEventListener('submit', function () {
      var lines = [];
      var fields = form.querySelectorAll('[data-pl-quote-field]');
      fields.forEach(function (el) {
        var value = valueOf(el);
        if (!value) return;
        lines.push(readableName(el) + ': ' + value);
      });
      bodyField.value = lines.length
        ? 'PrintiLoop quote request\n\n' + lines.join('\n')
        : 'PrintiLoop quote request';
    });
  }

  ready(initQuoteForm);
})();
